import type { ComponentType } from 'react';
import type { FilterDef } from '../filterTypes';
import type { FilterFieldProps } from '../FilterField.types';
import { BooleanFilterInput } from './BooleanFilterInput';
import { DateFilterInput } from './DateFilterInput';
import { ListFilterInput } from './ListFilterInput';
import { MonthYearFilterInput } from './MonthYearFilterInput';
import { NumericFilterInput } from './NumericFilterInput';
import { TextFilterInput } from './TextFilterInput';

/**
 * Maps each filter kind to its strategy component.
 *
 * To add a new filter kind:
 *   1. Create the strategy component in this folder.
 *   2. Add it here — no other files need to change.
 */
export const FILTER_FIELD_REGISTRY: Record<FilterDef['kind'], ComponentType<FilterFieldProps>> = {
  text: TextFilterInput as ComponentType<FilterFieldProps>,
  date: DateFilterInput as ComponentType<FilterFieldProps>,
  numeric: NumericFilterInput as ComponentType<FilterFieldProps>,
  boolean: BooleanFilterInput as ComponentType<FilterFieldProps>,
  list: ListFilterInput as ComponentType<FilterFieldProps>,
  monthYear: MonthYearFilterInput as ComponentType<FilterFieldProps>,
};
